'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

require('flickity-imagesloaded');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlogCarousel = function BlogCarousel(el) {
  (0, _classCallCheck3.default)(this, BlogCarousel);

  var carousels = (0, _functional.getElements)('[data-module="blog-carousel"]');

  var _loop = function _loop(i, len) {
    var galleryElem = carousels[i];
    var flkty = new _flickity2.default(galleryElem, {
      cellAlign: 'center',
      cellSelector: '.blg-List_Item',
      imagesLoaded: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      watchCSS: true,
      touchVerticalScroll: false,
      dragThreshold: 30
    });

    flkty.on('dragStart.el', function (event, pointer) {
      document.ontouchmove = function (e) {
        e.preventDefault();
      };
    });

    flkty.on('dragEnd.flickity', function (event, pointer) {
      document.ontouchmove = function (e) {
        return true;
      };
    });
    var tabsNav = (0, _functional.getElement)('.nav-Blog_Tabs');
    if (tabsNav) {
      tabsNav.addEventListener('click', function () {
        flkty.resize();
      });
    }
  };

  for (var i = 0, len = carousels.length; i < len; i++) {
    _loop(i, len);
  }
  // store tabs variable
  var myTabs = (0, _functional.getElements)('.nav-Blog_Tabs > li');
  function myTabClicks(tabClickEvent) {
    for (var i = 0; i < myTabs.length; i++) {
      myTabs[i].classList.remove('nav-Blog_Tab-active');
    }
    var clickedTab = tabClickEvent.currentTarget;
    clickedTab.classList.add('nav-Blog_Tab-active');
    tabClickEvent.preventDefault();
    var myContentPanes = (0, _functional.getElements)('.blog-Tab_Item');
    for (var _i = 0; _i < myContentPanes.length; _i++) {
      myContentPanes[_i].classList.remove('nav-Blog_Tab-active');
    }
    var anchorReference = tabClickEvent.target;
    var activePaneId = anchorReference.getAttribute('href');
    var activePane = (0, _functional.getElement)(activePaneId);
    activePane.classList.add('nav-Blog_Tab-active');
  }
  for (var i = 0; i < myTabs.length; i++) {
    myTabs[i].addEventListener('click', myTabClicks);
  }
};

exports.default = BlogCarousel;